import * as React from "react"
import Layout from "../components/layout"
import { StaticImage } from "gatsby-plugin-image" 
import VerticalTabs from '../components/verticalTabs'
import Carousel from "../components/carousel"


// markup
const Raconte = () => {


  const datas = [
    {
      title: 'Source enchantée <br /> La Corbelière – Pyrôme',
      img: '/abbaye/min/01.png',
    },
    {
      title: 'Trouver chaussure <br /> à son pied',
      img: '/abbaye/min/02.png',
    },
    {
      title: 'Chemin faisant <br /> à travers le bocage',
      img: '/abbaye/min/03.png',
    },
    {
      title: 'Le coin <br />des gourmands',
      img: '/abbaye/min/04.png',
    },
    {
      title: 'L’âge des pierres',
      img: '/abbaye/min/05.png',
    },
  ]

  return (
    <Layout>
      <div className="informations">
       
        <div className="pageTitle">
          <h1>L’Abbaye raconte...</h1>
        </div>
        
        <div className='boxContent reset'>
          <VerticalTabs datas={datas}>

            <div>
              <h3>
                Médiathèque
              </h3>
              <p>
                Retrouvez les Farfadets de Pyrôme dans le recueil de Contes et légendes du Pays Mauléonais collectés et rassemblés par le B.R.H.A.M. (Bureau de recherche historique et archéologique du Mauléonais).  
              </p>
              <StaticImage 
                src="../images/raconte/01/01.png" 
                alt="A dinosaur" 
                layout="fullWidth"
              />

              <h3>
                Musée
              </h3>
              <p>
                Au musée, percez les curiosités des rochers blancs de Pyrôme ! Il y a 420 Ma, naît l’immense chaîne de montagnes de granite, appelée chaîne Varisque, haute de 6000 m.  A Pyrôme, elle est percée d’une faille qui se remplit de quartz blanc. Au fil du temps, l’érosion fait disparaître les reliefs de granite alors que le quartz, qui résiste mieux à l’érosion, subsiste dans sa blancheur presque immaculée. Pour mieux comprendre ce phénomène, rendez-vous dans la cave du musée.
              </p>
              <Carousel autoPlay={false}>
                <StaticImage 
                  src="../images/raconte/01/02_01.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/01/02_02.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/01/02_03.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
              </Carousel>

              <h3>
                Office de Tourisme 
              </h3>
              <p>
                Tèrra aventura : C'est une balade originale, une chasse au trésor connectée, de quelques kilomètres qui permet de découvrir la région, le patrimoine local et naturel, des anecdotes, tout en s'amusant. Téléchargez l'application gratuite <a href="www.terra-aventura.fr" target="_blank">www.terra-aventura.fr</a>
              </p>
              
              <Carousel autoPlay={false}>
                <StaticImage 
                  src="../images/raconte/01/03_01.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/01/03_02.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/01/03_03.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
              </Carousel>
              <p className="creditPhoto">« V.Pegoraro/CD79 »</p>
              
            </div>


            <div>
              <h3>
                Médiathèque
              </h3>
              <p>
                Parcourez l'Histoire de la chaussure avec l'Encyclopédie de la chaussure du paléolithique supérieur au XXIème siècle, signée Bernard Parisot.
              </p>
              <StaticImage 
                src="../images/raconte/02/01.png" 
                alt="A dinosaur" 
                layout="fullWidth"
              />
              
              <h3>
                Musée
              </h3>
              <p>
                Le « Made in Mauléon », vous connaissez ? Au 19ème siècle, Mauléon connaît un véritable essor industriel avec l’implantation d’usines de tannage et de cordonnerie. Et ce n’est pas sous l’effet du hasard mais plutôt une évolution logique que vous allez comprendre au musée. Une vitrine est dédiée à toute la production de chaussures. Avez-vous un modèle préféré ? Trouverez-vous chaussure à votre pied ? 
              </p>
              <Carousel autoPlay={false}>
                <StaticImage 
                  src="../images/raconte/02/02_01.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/02/02_02.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/02/02_03.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
              </Carousel>


              <h3>
                Office de Tourisme 
              </h3>
              <p>
                Profitez des visites guidées originales de la ville de Mauléon pour découvrir avec vos 5 sens l'activité industrielle phare de celle ville : le travail du cuir. Pour repartir avec un souvenir, des objets en cuir sont également en vente en boutique.
              </p>
              <Carousel autoPlay={false}>
                <StaticImage 
                  src="../images/raconte/02/03_01.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/02/03_02.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/02/03_03.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/02/03_04.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
              </Carousel>
              <p className="creditPhoto">« P.Wall/CD79 »</p>

            </div>


            <div>
              <h3>
                Médiathèque
              </h3>
              <p>
                Découvrez Le Chêne de la Blandinière, le Châtaignier du chemin creux de Saint Amand ainsi que tous les Arbres remarquables des Deux-Sèvres présentés par l' Association Deux-Sèvres Nature Environnement.    
              </p>
              <Carousel autoPlay={false}>
                <StaticImage 
                  src="../images/raconte/03/01_01.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/03/01_02.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/03/01_03.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/03/01_04.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
              </Carousel>

              <h3>
                Musée
              </h3>
              <p>
                Le bocage : un paysage, une histoire… Qu’il soit normand ou bocain, le paysage de bocage est une zone rurale où des haies végétales délimitent les champs. Contrairement aux idées reçues, ce paysage n’est pas le fruit de la nature, il a été façonné par l’homme au sortir du Moyen-Age. Vous en apprendrez plus lors de votre visite au musée et les enfants pourront même s’amuser dans une structure dédiée à ce thème.
              </p>
              <StaticImage 
                src="../images/raconte/03/02.png" 
                alt="A dinosaur" 
                layout="fullWidth"
              />

              <h3>
                Office de Tourisme 
              </h3>
              <p>
                Découvrez la région à votre rythme en parcourant les 700 km de sentiers balisés soit une quarantaine de circuits. Vous trouverez les fiches rando en vente à l'office ou téléchargeable sur <a href="www.tourisme-bocage.mobi" target='_blank'>www.tourisme-bocage.mobi</a>
              </p>
              <Carousel autoPlay={false}>
                <StaticImage 
                  src="../images/raconte/03/03_01.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/03/03_02.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
              </Carousel>
              <p className="creditPhoto">« P.Wall/CD79 »</p>

            </div>


            <div>
              
              <h3>
                Médiathèque
              </h3>
              <p>
                Régalez-vous avec les spécialités du Bocage et du mauléonais en parcourant les livres de recettes du Poitou-Charentes.
              </p>
              <Carousel autoPlay={false}>
                <StaticImage 
                  src="../images/raconte/04/01_01.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/04/01_02.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/04/01_03.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/04/01_04.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
              </Carousel>

              <h3>
                Musée
              </h3>
              <p>
                Elle s’appelle « La Merveilleuse », mais de quoi s’agit-il ? Venez découvrir cet objet insolite créé par la société Guéry à Mauléon en 1926… Un indice ? On versait dans sa cuve la crème de lait pour la transformer en beurre grâce à des malaxeurs, actionnés manuellement avec une poignée… Vous avez deviné : une baratte à beurre !
              </p>
              <StaticImage 
                src="../images/raconte/04/02.png" 
                alt="A dinosaur" 
                layout="fullWidth"
              />

              <h3>
                Office de Tourisme 
              </h3>
              <p>
                Allez à la rencontre des producteurs locaux dans les marchés traditionnels ou lors des marchés évènementiels l'été. Découvrez nos spécialités dont le Mauléonais, un mélange subtil et aérien d'une crème mousseline sur un gâteau léger.
              </p>
              <Carousel autoPlay={false}>
                <StaticImage 
                  src="../images/raconte/04/03_01.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/04/03_02.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/04/03_03.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
              </Carousel>
              <p className="creditPhoto">« V.Pegoraro/CD79 »</p>

            </div>


            <div>
              <h3>
                Médiathèque
              </h3>
              <p>
                Suivez les aventures de Cromignon et Cropetite dans les albums pour enfants de Michel GAY.
              </p>
              <Carousel autoPlay={false}>
                <StaticImage 
                  src="../images/raconte/05/01_01.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/05/01_02.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/05/01_03.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
              </Carousel>

              <h3>
                Musée
              </h3>
              <p>
                Une invitation à remonter le temps… de la période préhistorique à l’Age du Bronze avec les mystérieux rochers gravés des Vaulx, classés Monuments Historiques. Leurs gravures évoquent des personnages, des animaux et divers symboles. Un site exceptionnel à découvrir au musée et aussi sur le site naturel à Saint-Aubin-de-Baubigné.  
              </p>
              <StaticImage 
                src="../images/raconte/05/02.png" 
                alt="A dinosaur" 
                layout="fullWidth"
              />

              <h3>
                Office de Tourisme 
              </h3>
              <p>
                Enclavé dans son écrin de verdure, le dolmen de la Voie est à découvrir. Il daterait de plus de 5 000 ans et témoigne de la présence des Celtes au Pin. Ce dolmen est tout ce qu’il reste d’une ancienne allée couverte. On y accède par un circuit de randonnée (Les chemins creux - Le Pin)
              </p>
              <Carousel autoPlay={false}>
                <StaticImage 
                  src="../images/raconte/05/03_01.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
                <StaticImage 
                  src="../images/raconte/05/03_02.png" 
                  alt="A dinosaur" 
                  layout="fullWidth"
                />
              </Carousel>
            </div>


          </VerticalTabs>
        </div>

      </div>
    </Layout>
  )
}

export default Raconte
